<p-toast position="bottom-center" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO" rejectButtonStyleClass="p-button-text" styleClass="dark-confirm"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
    rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar dark-confirm"
    [rejectVisible]="false"></p-confirmDialog>
<!-- para modificar resolucion <div class="d-flex justify-content-center " style="transform: scale(0.75); transform-origin: top left; width: 133.33%; overflow-x: hidden;"></div> -->
<div class="w-100">
    <div class="tabulador-page w-100 px-0" style="width: 100%;">
        <div class="tabulador-card">
            <div class="row mt-3">
                <div class="col-md-12">
                        <div class="card-header sinborde d-flex justify-content-between align-items-end pb-3" style="background: none;">
                        <div class="d-flex align-items-center">
                                <div class="cardicono rounded ml-2">
                                    <i class="pi pi-calculator" style="font-size: 2rem; color: #fff;"></i>
                                </div>
                                
                                <div class="ml-4 mb-2" style="border: none;"> 
                                    <span class="tabulador-title">
                                        Tabulador de Costos Cliente <b class="texto_titulo">{{this.NombreEmpresaGlobal}}</b>
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex" style="gap: 15px;">
                                        <button pButton type="button" label="Regresar" icon="pi pi-arrow-circle-left"  style="height: 50px;"
                                        class="p-button-raised p-button-secondary mt-2" 
                                        (click)="Regresar()" pTooltip="Regresar a Clientes" tooltipPosition="bottom">
                                    </button>
                                    <div class="col-2">
                                        <p-splitButton [model]="opciones" icon="pi pi-cog" label="Opciones"/>
                                        <input 
                                        type="file"
                                        #fileUpload
                                        style="display: none;"
                                        (change)="onExcelUpload($event)"
                                        accept=".xlsx, .xls" />
                                    </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="mt-3 w-100">
                                <p-table #dt1 [value]="TabuladorCostos" [tableStyle]="{'min-width': '260rem'}" scrollHeight="flex"
                                    styleClass="tabulador-enterprise" dataKey="id" responsiveLayout="scroll"
                                    [scrollable]="true" [paginator]="true" [pAutoLayout]="false"
                                    [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
                                    [virtualScrollItemSize]="15"
                                    [showCurrentPageReport]="true"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                                    [globalFilterFields]="['config_unidad']">
                                    <ng-template pTemplate="caption" let-data>
                                        <div class="flex">
                                            <button pButton label="Limpiar" class="p-button-outlined mr-2"
                                                icon="pi pi-filter-slash" (click)="clear(dt1)">
                                            </button>
                                            <p-columnFilter class="ml-4" field="clv_aceptado" matchMode="equals"
                                                [showMenu]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <p-dropdown [ngModel]="value" [options]="estatusPropuesta"
                                                        optionLabel="label" optionValue="value"
                                                        (onChange)="filter($event.value)" placeholder="Filtrar por estatus"
                                                        [showClear]="true">
                                                    </p-dropdown>
                                                </ng-template>
                                            </p-columnFilter>
                                            <p-button label="Exportar Todo a Excel" severity="success" 
                                                class="p-button-success p-button-rounded" icon="pi pi-file-excel"
                                                (click)="GenerarTodoAExcel()">
                                            </p-button>
                                            <span class="p-input-icon-left ml-auto">
                                                <input pInputText type="text"
                                                    (input)="applyFilterGlobal($event, 'contains')"
                                                    placeholder="Buscar: Configuracion de unidad, No. Días, PDV" size="40" />
                                            </span>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr [ngClass]="{'texto_sm':true}">
                                            <th pFrozenColumn style="min-width:5rem;width: 5rem;">
                                                #
                                            </th>
                                            <th pFrozenColumn style="min-width:5rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Corrida.
                                                </div>
                                            </th>
                                            <th pFrozenColumn style="min-width:8rem; width: 8rem;">
                                                <div class="flex align-items-center">
                                                    Configuración
                                                </div>
                                            </th>
                                            <th pFrozenColumn style="min-width:12rem;width: 12rem;">
                                                <div class="flex align-items-center">
                                                    Origen
                                                    <p-columnFilter type="text" field="des_origen"
                                                        display="menu"></p-columnFilter>
                                                </div>
                                            </th>
                                            <th pFrozenColumn style="min-width:12rem;width: 12rem;">
                                                <div class="flex align-items-letf">
                                                    Destino
                                                    <p-columnFilter type="text" field="des_destino"
                                                        display="menu"></p-columnFilter>
                                                </div>
                                            </th>
                                            <th pFrozenColumn style="min-width:12rem;width: 12rem;">
                                                <div class="flex align-items-letf">
                                                    Escala
                                                    <p-columnFilter type="text" field="des_escala"
                                                        display="menu"></p-columnFilter>
                                                </div>
                                            </th>
                                            <th pSortableColumn="num_dias" style="min-width:8rem; width: 8rem;">
                                                <div class="flex align-items-center">
                                                    Número de Días
                                                    <p-sortIcon field="num_dias"></p-sortIcon>
                                                </div>
                                            </th>
                                            <th style="min-width:9rem;width: 9rem;">
                                                <div class="flex align-items-center">
                                                    Número de Kilometros
                                                </div>
                                            </th>
                                            <th style="min-width:8rem;width: 8rem;">
                                                <div class="flex align-items-center">
                                                    Importe Peaje
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Costo
                                                    <p-columnFilter type="text" field="costo"
                                                        display="menu"></p-columnFilter>
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Costo con urea sin iva en peajes
                                                    <p-columnFilter type="text" field="imp_preciodeventa"
                                                        display="menu"></p-columnFilter>
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Precio de Venta
                                                    
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Utilidad
                                                    
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Utilidad con urea sin iva en peajes
                                                    
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Porcentaje de margen
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Porcentaje de utilidad
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Dias de frecuencia
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Precio de frecuencia
                                                </div>
                                            </th>
                                            <th  style="min-width:11rem;width: 11rem;">
                                            <div class="flex align-items-left">
                                                Perfil de ruta
                                                <p-columnFilter field="id_perfil_ruta" display="menu" [showOperator]="false" type="equals">
                                                <ng-template pTemplate="filterElement" let-value let-filter="filterCallback">
                                                    <p-dropdown
                                                    [options]="[
                                                        { label: 'ZONA INDUSTRIAL', value: 1 },
                                                        { label: 'ZONA METROPOLITANA', value: 2 }
                                                    ]"
                                                    [placeholder]="'Selecciona zona'"
                                                    [showClear]="true"
                                                    [style]="{ width: '100%' }"
                                                    [ngModel]="value"
                                                    (onChange)="filter($event.value)"
                                                    ></p-dropdown>
                                                </ng-template>
                                                </p-columnFilter>
                                            </div>
                                            </th>
                                            <th style="min-width:9rem;width: 9rem;">
                                                <div class="flex align-items-center">
                                                    Imp. perfil ruta
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Número de Choferes
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Número de Auxiliares
                                                </div>
                                            </th>
                                             <th style="min-width:3rem;width: 3rem;">
                                                <div class="flex align-items-center">
                                                    Num. Stop
                                                </div>
                                            </th>
                                            <th style="min-width:4rem;width: 4rem;">
                                                <div class="flex align-items-center">
                                                    Imp. Stop
                                                </div>
                                            </th>
                                            <th style="min-width:3rem;width: 3rem;">
                                                <div class="flex align-items-center">
                                                    Maniobras
                                                </div>
                                            </th>
                                            <th style="min-width:4rem;width: 4rem;">
                                                <div class="flex align-items-center">
                                                    Imp. Maniobras
                                                </div>
                                            </th>
                                            <th style="min-width:3rem;width: 3rem;">
                                                <div class="flex align-items-center">
                                                    Truck
                                                </div>
                                            </th>
                                            <th style="min-width:4rem;width: 4rem;">
                                                <div class="flex align-items-center">
                                                    Cost. Km
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Sueldo Chofer
                                                </div>
                                            </th>
                                            <th style="min-width:4rem;width: 4rem;">
                                                <div class="flex align-items-center">
                                                    Sueldo Total Chofer
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Sueldo Auxiliar
                                                </div>
                                            </th>
                                            <th *ngIf="shouldShowHospedaje" style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Gasto Hospedaje
                                                </div>
                                            </th>
                                            <th *ngIf="shouldShowHospedaje" style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Gasto Viaticos
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Gasto Combusible
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Gasto Comisión Combusible
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Gasto Urea
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Herramientas de Seguridad y Monitoreo
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Recursos Humanos
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Vehiculos
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Mantenimiento Preventivo
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Servicio Correctivo
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Importe Llantas
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Propuesta de Valor
                                                </div>
                                            </th>
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Permisos de Circulacion
                                                </div>
                                            </th>
                                            <!-- <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Combustibles y Casetas
                                                </div>
                                            </th> -->
                                            <th style="min-width:10rem;width: 10rem;">
                                                <div class="flex align-items-center">
                                                    Estatus Final
                                                </div>
                                            </th>
                                            <th style="min-width:4rem;width: 4rem;">
                                                <div class="flex align-items-center">
                                                    Tabulador
                                                </div>
                                            </th>
                                            
                                            
                                            <th style="min-width: 4rem; width: 4rem; text-align: center;">
                                                <div class="flex justify-content-center">
                                                    </div>
                                            </th>
                                            <th style="min-width: 14rem; width: 14rem; text-align: center;">
                                                </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-data let-index="rowIndex" let-editing="editing">
                                    <tr [ngClass]="{
                                        'row-accessories': data.clv_activo === 0,
                                        'row-alerta-gerente': data.clv_candado_hrs === 1 && (data.clv_enviado === 0 || data.clv_enviado === 2)
                                        }" 
                                        class="tabulador-row">
                                            <td pFrozenColumn [frozen]="true"  class="texto_negrita" style="min-width:3rem;width: 3rem;">
                                                {{(index+1)}}
                                            </td>
                                            <td pFrozenColumn [frozen]="true" class="texto_negrita" style="min-width:5rem;width: 5rem;">
                                                <div><i class="fa-solid fa-hashtag"></i> {{data.id_corrida}}</div>
                                            </td>
                                            <td pFrozenColumn [frozen]="true" class="texto_negrita texto_naranja_ba" style="min-width:8rem;width: 8rem;">
                                                <div>
                                                    <i class="fa-solid fa-van-shuttle" style="color: #e09200;"></i> {{data.config_unidad}}
                                                </div>
                                            </td>
                                            <td pFrozenColumn [frozen]="true" class="texto_negrita " style="min-width:12rem;width: 12rem;">
                                                <div><i class="fa-solid fa-map-location-dot" style="color: #7c7c00;">&nbsp;</i>{{data.des_origen}}</div>
                                            </td>
                                            <td pFrozenColumn  [frozen]="true" class="texto_negrita"style="min-width:12rem;width: 12rem;">
                                                <div><i class="fa-solid fa-map-location-dot" style="color: #7c7c00;">&nbsp;</i>{{data.des_destino}}</div>
                                            </td>
                                            <td pFrozenColumn [frozen]="true"  class="texto_negrita" style="min-width:12rem;width: 12rem;">
                                                <div><i class="fa-solid fa-map-location-dot" style="color: #7c7c00;">&nbsp;</i>{{data.des_escala}}</div>
                                            </td>
                                            <td  class="texto_negrita" style="min-width:8rem;width: 8rem;">
                                                <div class="texto_negrita"><i class="fa-regular fa-calendar-days color-icon"
                                                        style="font-size: 1.3rem;"></i> {{data.num_dias}}</div>
                                            </td>
                                            <td   style="min-width:9rem;width: 9rem;">
                                                <div class="texto_negrita"><i class="fa-solid fa-gauge"
                                                        style="font-size: 1.3rem;"></i> {{data.num_kilometros}}</div>
                                            </td>
                                            <td style="min-width:8rem;width: 8rem;">
                                                <div class="texto_negrita"> {{data.imp_peaje|currency}}</div>
                                            </td>
                                            <td>
                                                <div class="texto_negrita"style="min-width:10rem;width: 10rem;">{{data.costo| currency}} &nbsp;<i
                                                        class="fa-solid fa-chart-line char"
                                                        style="color: rgb(115, 107, 186); font-size: 1.6rem; padding-top: 4px;"
                                                        pTooltip="Ver Grafica del Costo" (click)="VerGrafica(data)"></i>
                                                </div>
                                            </td>
                                            <td style="min-width:8rem;width: 8rem;">
                                                <div class="texto_negrita"> {{data.imp_costo_urea_sin_iva_peaje|currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="valor-positivo ">{{data.imp_preciodeventa| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_utilidad| currency}} <i
                                                        style="color:#2454B8 !important;font-size: 1.4rem;"
                                                        class="fa-solid fa-circle-info color-icon"
                                                        pTooltip="El Porcentaje de Utilidad es {{data.num_porcentajeutd}}%"></i>
                                                </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita colo">{{data.imp_utilidad_urea_sin_iva_peaje| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-solid fa-percent"
                                                        style="font-size: 1.3rem ; color: #0589ee;"></i> {{data.num_margen}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-solid fa-percent"
                                                        style="font-size: 1.3rem ; color: #0589ee;"></i> {{data.num_porcentajeutd}}</div>
                                            </td>
                                            <td style="min-width:10rem;width:10rem;">
                                            <div class="texto_negrita d-flex justify-content-center align-items-center">
                                                {{ data.num_dias_frecuencia }}
                                            </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_precio_de_frecuencia| currency}}</div>
                                            </td>
                                            <td  style="min-width:11rem; width: 11rem;">
                                            <div class="texto_negrita">
                                                    <i class="fa-solid fa-house-user" style="font-size: 1.3rem;"></i>
                                                    {{ data.id_perfil_ruta === 1 ? 'ZONA INDUSTRIAL' : data.id_perfil_ruta === 2 ? 'ZONA METROPOLITANA' : '' }}
                                                </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_perfil_ruta| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-regular fa-user"
                                                        style="font-size: 1.3rem;"></i> {{data.num_choferes}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-regular fa-user"
                                                        style="font-size: 1.3rem;"></i> {{data.num_auxiliares}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.num_stop_in }}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_stop|currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.clv_maniobras_in==1?'SI':'NO'  }}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_maniobras|currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.clv_truck_in==1?'SI':'NO'  }}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_costo_kilometros|currency}}</div>
                                            </td>                               
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_sueldochofer| currency}}</div>
                                            </td>
                                            <td>
                                                <div class="texto_negrita">{{data.sueldo_total_chofer|currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_sueldoaux| currency}}</div>
                                            </td>
                                            <td *ngIf="data.num_dias>0" style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-solid fa-house-user"
                                                        style="font-size: 1.3rem;"></i> {{data.imp_hospedaje| currency}}
                                                </div>
                                            </td>
                                            <td *ngIf="data.num_dias>0" style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"><i class="fa-solid fa-money-bill"
                                                        style="font-size: 1.3rem;"></i> {{data.imp_viaticos| currency}}
                                                </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_combustible| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_comisioncombustible| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_urea| currency}}
                                                </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> 
                                                    {{data.imp_cel_gps | currency}}  
                                                    &nbsp;<i style="color:#2454B8 !important;font-size: 1.4rem;" *ngIf="data.clv_tabuladordetalle==1"
                                                        class="fa-solid fa-circle-info color-icon"
                                                        pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,5)">
                                                    </i>
                                                </div>
                                            </td>                                        
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_imss| currency}}&nbsp;<i
                                                    style="color:#2454B8 !important;font-size: 1.4rem;" *ngIf="data.clv_tabuladordetalle==1"
                                                    class="fa-solid fa-circle-info color-icon"
                                                    pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,2)"></i></div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita">{{data.imp_depreciacion|currency}}&nbsp;
                                                     <i
                                                        style="color:#2454B8 !important;font-size: 1.4rem;" *ngIf="data.clv_tabuladordetalle==1"
                                                        class="fa-solid fa-circle-info color-icon"
                                                        pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,1)"></i>
                                                </div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_mantenimiento| currency}}&nbsp;<i *ngIf="data.clv_tabuladordetalle==1"
                                                    style="color:#2454B8 !important;font-size: 1.4rem;"
                                                    class="fa-solid fa-circle-info color-icon"
                                                    pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,7)"></i></div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_serviciocorrectivo| currency}}&nbsp;<i
                                                    style="color:#2454B8 !important;font-size: 1.4rem;" *ngIf="data.clv_tabuladordetalle==1"
                                                    class="fa-solid fa-circle-info color-icon"
                                                    pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,8)"></i></div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_llantas| currency}}</div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_propuestavalor| currency}}&nbsp;<i *ngIf="data.clv_tabuladordetalle==1"
                                                    style="color:#2454B8 !important;font-size: 1.4rem;"
                                                    class="fa-solid fa-circle-info color-icon"
                                                    pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,3)"></i></div>
                                            </td>
                                            <td style="min-width:10rem;width: 10rem;">
                                                <div class="texto_negrita"> {{data.imp_permisocirculacion| currency}}&nbsp;<i *ngIf="data.clv_tabuladordetalle==1"
                                                    style="color:#2454B8 !important;font-size: 1.4rem;"
                                                    class="fa-solid fa-circle-info color-icon"
                                                    pTooltip="Ver el Desglose Detallado" (click)="ObtenerTabuladorDetalle(data,4)"></i></div>
                                            </td>
                                                
                                            <td style="min-width: 10rem; width: 10rem;" class="text-center">
                                                <label class="switch" 
                                                    [pTooltip]="data.clv_enviado === 1 ? 'Aprobado y Enviado' : (data.clv_enviado === 2 ? 'Pendiente Autorización Gerente' : 'No Enviado')" 
                                                    tooltipPosition="top">
                                                    
                                                    <input type="checkbox" 
                                                        [checked]="data.clv_enviado > 0" 
                                                        (change)="onEstatusPropuestaChange($event, data)" 
                                                        [disabled]="data.clv_enviado > 0" 
                                                        aria-label="Cambiar estado">
                                                        
                                                    <span class="slider round"
                                                        [ngClass]="{
                                                            'slider-verde': data.clv_enviado === 1,
                                                            'slider-naranja': data.clv_enviado === 2
                                                        }">
                                                    </span>
                                                </label>
                                            </td>
                                            <td style="min-width: 4rem; width: 4rem;">
                                            <p-splitButton 
                                            [model]="opcTabulado" 
                                            icon="pi pi-list" 
                                            [appendTo]="'body'" 
                                            label="Opciones" 
                                            severity="secondary" 
                                            (onClick)="Mostrar(data)" 
                                            (onDropdownClick)="Mostrar(data)" 
                                            outlined />
                                            </td>        
                                            <td style="min-width: 2rem; max-width: 2rem;">
                                                
                                                    <button *ngIf="data.clv_enviado === 0" 
                                                            pButton 
                                                            type="button" 
                                                            icon="pi pi-trash" 
                                                            class="p-button-danger p-button-raised"
                                                            pTooltip="Eliminar Cotización" 
                                                            tooltipPosition="top"
                                                            (click)="EliminarTabulado(data)">
                                                    </button>
                                                
                                            </td>
                                            <td style=" max-width: 2rem;">
                                                <button pButton label="Exportar a Excel" class="p-button-outlined qolor"
                                                    icon="pi pi-file-excel"
                                                    style="color: #ffffff; background-color: rgb(62, 139, 86)"
                                                    (click)="GenerarExcel(data)">
                                                </button>
                                            </td>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="7">Sin Tabulados.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
    
<p-dialog 
styleClass="tabulador-dialog-premium"
[(visible)]="dspTabuladorDiario"
[modal]="true"
[responsive]="true"
[style]="{ width: '55vw' }"
[draggable]="false">

<!-- HEADER -->
<ng-template pTemplate="header">
  <div class="dialog-header">
    <i class="pi pi-chart-line mr-2"></i>
    Información del Tabulador
  </div>
</ng-template>

<div class="tabulador-content mt-2" *ngFor="let item of tabuladorDiarioData">

  <!-- 🔹 BLOQUE RUTA -->
  <div class="resumen-card">
    <div class="card-title">
      <i class="pi pi-map-marker mr-2"></i>
      Detalle de la Ruta
    </div>

    <div class="ruta-highlight">
      {{item.des_origen}} → {{item.des_destinos}}
      <span *ngIf="item.des_escala"> | Escala: {{item.des_escala}}</span>
    </div>

    <div class="mini-grid">
      <div>
        <span class="label">Días de Ruta</span>
        <span class="value highlight-orange">{{item.num_dias}}</span>
      </div>

      <div>
        <span class="label">Días Hospedaje</span>
        <span class="value highlight-orange">{{item.num_dias_hospedaje}}</span>
      </div>
    </div>
  </div>

  <!-- 🔹 BLOQUE PERSONAL -->
  <div class="resumen-card">
    <div class="card-title">
      <i class="pi pi-users mr-2"></i>
      Personal
    </div>

    <div class="mini-grid">
      <div>
        <span class="label">Choferes</span>
        <span class="value">{{item.num_choferes}}</span>
      </div>

      <div>
        <span class="label">Auxiliares</span>
        <span class="value">{{item.num_auxiliares}}</span>
      </div>
    </div>
  </div>

  <!-- 🔹 BLOQUE FINANCIERO -->
  <div class="resumen-card financiero">
    <div class="card-title">
      <i class="pi pi-wallet mr-2"></i>
      Costos
    </div>
    <div class="cost-grid">
      <div>
        <span class="label">Sueldo Chofer</span>
        <span class="value money">{{item.imp_individual_chofer | currency}}</span>
      </div>

      <div>
        <span class="label">Sueldo Auxiliar</span>
        <span class="value money">{{item.imp_individual_aux | currency}}</span>
      </div>

      <div>
        <span class="label">Alimentación Chofer</span>
        <span class="value money">{{item.imp_alimento_chofer | currency}}</span>
      </div>

      <div>
        <span class="label">Alimentación Auxiliar</span>
        <span class="value money">{{item.imp_alimento_aux | currency}}</span>
      </div>

      <div>
        <span class="label">Hospedaje Chofer</span>
        <span class="value money">{{item.imp_estancia_chofer | currency}}</span>
      </div>

      <div>
        <span class="label">Hospedaje Auxiliar</span>
        <span class="value money">{{item.imp_estancia_aux | currency}}</span>
      </div>
    </div>
  </div>
  <!-- 🔹 NOTAS -->
  <div class="nota-box">
    <b>Nota:</b><br>
    • Sueldo: Importe total del colaborador según su puesto.<br>
    • Viáticos: Total asignado por ruta según puesto.<br>
    • Hospedaje: Total generado durante la ruta.
  </div>
</div>

<p-footer>
  <button 
    pButton 
    type="button" 
    label="Cerrar" 
    icon="pi pi-times"
    class="p-button-text"
    (click)="cancelarVentanaModal()">
  </button>
</p-footer>

</p-dialog>
    <p-dialog [resizable]="false" [closeOnEscape]="false" [draggable]="false" [(visible)]="dspTabulador" [modal]="true" (onHide)="cancelarVentanaModal()"
        [style]="{width: '90vw','height':'1150px'}" [transitionOptions]="'0ms'" styleClass="card-shadow">
        <ng-template pTemplate="header"><span class="dialog-title"><i class="pi pi-plus-circle"></i>Agregar Tabulador</span></ng-template>
        <ng-template pTemplate="content">
            <div class="tabulador-wrapper" *ngIf="dspTablaRegreso===false">
                            <form class="tabulador-form" [formGroup]="tabuladorForm">
                                <div class="ml-2 px-2">
                                            <div class="row mt-5 form-card">
                                                <span style="color: #2454B8;">
                                                    <h2><i class="pi pi-wallet" style="font-size: 2rem;"></i> Información Base
                                                        Para el Cliente:</h2>
                                                </span>
                                            </div>
                                            <div class="config-panel mt-4">

                                                <div class="panel-header">
                                                  <i style="font-size: 1.3rem;" class="pi pi-info-circle mr-2"></i>
                                                  Información General
                                                </div>
                                              
                                                <div class="panel-grid">
                                              
                                                  <div class="field-group">
                                                    <label>Centro de Costos</label>
                                                    <p-dropdown
                                                      [options]="centrosCostosHm"
                                                      optionLabel="municipio"
                                                      optionValue="id"
                                                      placeholder="Seleccione un centro"
                                                      formControlName="centro_costos"
                                                      [showClear]="true"
                                                      class="w-full">
                                                    </p-dropdown>
                                                  </div>
                                              
                                                  <div class="field-group">
                                                    <label>Maniobras</label>
                                                    <p-dropdown
                                                      [options]="opcionesSiNo"
                                                      optionLabel="label"
                                                      optionValue="value"
                                                      placeholder="Seleccione"
                                                      formControlName="maniobras"
                                                      [showClear]="true"
                                                      class="w-full">
                                                    </p-dropdown>
                                                  </div>
                                              
                                                  <div class="field-group">
                                                    <label>Número de Stops</label>
                                                    <input
                                                      pInputText
                                                      type="number"
                                                      min="0"
                                                      formControlName="num_stop"
                                                      class="modern-input w-full"
                                                      placeholder="0">
                                                  </div>
                                              
                                                </div>
                                              
                                              </div>
                                            
                                             <!-- CARD 2: RUTA -->
                                             <div class="config-panel mt-4">

                                                <div class="panel-header">
                                                  <i style="font-size: 1.3rem;"  class="pi pi-map-marker mr-2"></i>
                                                  Ruta
                                                </div>
                                              
                                                <div class="panel-grid">
                                              
                                                  <!-- Tipo de Ruta -->
                                                  <div class="field-group">
                                                    <label>Tipo de Ruta</label>
                                                    <p-dropdown
                                                      [options]="cat_Rutas"
                                                      placeholder="Selecciona el Tipo de Ruta"
                                                      [(ngModel)]="idruta"
                                                      optionLabel="nom_area"
                                                      optionValue="id_area"
                                                      formControlName="Area"
                                                      [showClear]="true"
                                                      [appendTo]="'body'"
                                                      class="w-full">
                                                    </p-dropdown>
                                                  </div>
                                              
                                                  <!-- Origen -->
                                                  <div class="field-group">
                                                    <label class="d-flex align-items-center">
                                                      <i style="font-size: 1.1rem;" class="fa-solid fa-city mr-2 color-icon"></i>
                                                      Origen
                                                    </label>
                                              
                                                    <div class="modern-input-group">
                                                      <input
                                                        pInputText
                                                        type="text"
                                                        [(ngModel)]="googleOrigenSearch"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        placeholder="Ej. Culiacán, Sinaloa, México"
                                                        class="w-full">
                                                      
                                                      <button
                                                        pButton
                                                        type="button"
                                                        icon="pi pi-search"
                                                        class="p-button-outlined p-button-secondary"
                                                        (click)="buscarDireccionGoogle('origen')"
                                                        pTooltip="Buscar Origen"
                                                        tooltipPosition="top">
                                                      </button>
                                                    </div>
                                              
                                                    <small class="helper-text">
                                                      {{ valNotNullAddress('origenAddr') }}
                                                    </small>
                                                  </div>
                                              
                                                  <!-- Destino -->
                                                  <div class="field-group">
                                                    <label class="d-flex align-items-center">
                                                      <i style="font-size: 1.1rem;"  class="fa-solid fa-city mr-2 color-icon"></i>
                                                      Destino
                                                    </label>
                                              
                                                    <div class="modern-input-group">
                                                      <input
                                                        pInputText
                                                        type="text"
                                                        [(ngModel)]="googleDestinoSearch"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        placeholder="Ej. Guadalajara, Jalisco, México"
                                                        class="w-full">
                                                      
                                                      <button
                                                        pButton
                                                        type="button"
                                                        icon="pi pi-search"
                                                        class="p-button-outlined p-button-secondary"
                                                        (click)="buscarDireccionGoogle('destino')"
                                                        pTooltip="Buscar Destino"
                                                        tooltipPosition="top">
                                                      </button>
                                                    </div>
                                              
                                                    <small class="helper-text">
                                                      {{ valNotNullAddress('destinoAddr') }}
                                                    </small>
                                                  </div>
                                              
                                                </div>
                                              
                                              </div>

                                            <div class="ruta-container">

                                                <div class="ruta-header">
                                                  <div class="ruta-title">
                                                    <i class="pi pi-map-marker mr-2"></i>
                                                    Ruta con Escalas
                                                    <span class="ruta-sub">(Máx. {{maxParadas}})</span>
                                                  </div>
                                              
                                                  <button
                                                    pButton
                                                    type="button"
                                                    icon="pi pi-plus"
                                                    label="Agregar parada"
                                                    class="p-button-sm p-button-outlined"
                                                    (click)="agregarParada()"
                                                    [disabled]="paradas.length >= maxParadas">
                                                  </button>
                                                </div>
                                              
                                                <div formArrayName="paradas" class="timeline">
                                              
                                                  <div
                                                    *ngFor="let paradaCtrl of paradas.controls; let i = index"
                                                    [formGroupName]="i"
                                                    class="timeline-item">
                                              
                                                    <!-- Línea vertical -->
                                                    <div class="timeline-marker">
                                                      <div class="circle">{{ i + 1 }}</div>
                                                      
                                                    </div>
                                              
                                                    <!-- Contenido -->
                                                    <div class="timeline-content">
                                              
                                                      <div class="input-row">
                                                        <input
                                                          pInputText
                                                          type="text"
                                                          formControlName="texto"
                                                          placeholder="Ciudad, Estado, País" />
                                              
                                                        <button
                                                          pButton
                                                          type="button"
                                                          icon="pi pi-search"
                                                          class="p-button-text"
                                                          (click)="buscarDireccionGoogle('parada', i)">
                                                        </button>
                                              
                                                        <button
                                                          pButton
                                                          type="button"
                                                          icon="pi pi-trash"
                                                          class="p-button-rounded p-button-danger p-button-text"
                                                          (click)="eliminarParada(i)">
                                                        </button>
                                                      </div>
                                              
                                                      <div class="direccion-preview">
                                                        {{ valNotNullAddress('escalaAddr', i) }}
                                                      </div>
                                              
                                                    </div>
                                              
                                                  </div>
                                              
                                                </div>
                                                <div class="row mt-4">
                                                    <div class="col-12 d-flex justify-content-end">
                                                      <button
                                                        pButton
                                                        type="button"
                                                        icon="pi pi-compass"
                                                        label="Calcular KM"
                                                        class="p-button-rounded p-button-success px-4 shadow-2"
                                                        (click)="calcularRuta()"
                                                        [disabled]="tabuladorForm.get('tipo_tabulado')?.value !== 1">
                                                      </button>
                                                    </div>
                                                  </div>
                                              
                                              </div>

                                              <div class="config-module">

                                                <!-- HEADER -->
                                                <div class="config-header">
                                                  <div>
                                                    <div class="config-title">
                                                      <i class="fa-solid fa-truck mr-2"></i>
                                                      Configuración de Unidades
                                                    </div>
                                                    <div class="config-sub">
                                                      Define el importe de caseta y utilidad por tipo de unidad.
                                                    </div>
                                                  </div>
                                                </div>
                                              
                                                <!-- SELECTOR -->
                                                <div class="config-selector">
                                                  <p-multiSelect 
                                                    [options]="cat_ConfiguracionUnidades"
                                                    [(ngModel)]="configuracionesSeleccionadas"
                                                    optionValue="idx_respaldo_confunidad"
                                                    optionLabel="nombre"
                                                    formControlName="configuracion_Unidad"
                                                    display="chip"
                                                    [appendTo]="'body'"
                                                    [style]="{'width':'100%'}"
                                                    (ngModelChange)="Config()"
                                                    (onChange)="handleChange($event)">
                                                  </p-multiSelect>
                                                </div>
                                              
                                                <!-- RESUMEN -->
                                                <div *ngIf="objImporteCaseta.length > 0" class="config-summary">
                                                  <div class="summary-title">
                                                    <i class="pi pi-check-circle mr-2"></i>
                                                    Configuraciones Guardadas
                                                  </div>
                                              
                                                  <div class="summary-grid">
                                                    <div *ngFor="let item of objImporteCaseta" class="summary-card">
                                                      <div class="summary-name">
                                                        {{ getNombreConfiguracion(item.id_configuracion) }}
                                                      </div>
                                              
                                                      <div class="summary-values">
                                                        <span class="importe">
                                                          {{ item.importeCasetaConfiguracion | currency:'MXN' }}
                                                        </span>
                                                        <span class="utilidad">
                                                          {{ item.porcentajeUtilidadConfiguracion }}%
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              
                                                <!-- FORMULARIOS DINÁMICOS -->
                                                <div class="config-forms">
                                              
                                                  <div *ngFor="let configuracionimporte of importesForms; let i = index"
                                                       [formGroup]="configuracionimporte"
                                                       class="config-card">
                                              
                                                    <div class="card-header-custom">
                                                      <span class="card-title">
                                                       {{ configuracionimporte.get('nombre')?.value }}
                                                      </span>
                                                    </div>
                                              
                                                    <div class="card-body-custom">
                                              
                                                      <div class="form-row-custom">
                                              
                                                        <!-- IMPORTE -->
                                                        <div class="form-group-custom">
                                                          <label>Importe Caseta</label>
                                                          <p-inputNumber
                                                            mode="currency"
                                                            currency="MXN"
                                                            formControlName="importeCasetaConfiguracion"
                                                            [style]="{'width':'100%'}"
                                                            [showClear]="!rutaCalculada">
                                                          </p-inputNumber>
                                                        </div>
                                              
                                                        <!-- UTILIDAD -->
                                                        <div class="form-group-custom">
                                                          <label>% Utilidad</label>
                                                          <p-inputNumber
                                                            suffix="%"
                                                            formControlName="porcentajeUtilidadConfiguracion"
                                                            [min]="0"
                                                            [max]="100"
                                                            [style]="{'width':'100%'}">
                                                          </p-inputNumber>
                                                        </div>
                                              
                                                        <!-- BOTÓN -->
                                                        <div class="form-button-custom">
                                                          <button
                                                            pButton
                                                            type="button"
                                                            icon="pi pi-check"
                                                            label="Guardar"
                                                            class="p-button-success"
                                                            (click)="addImporteForm(configuracionimporte,i)"
                                                            [disabled]="!configuracionimporte.valid">
                                                          </button>
                                                        </div>
                                              
                                                      </div>
                                              
                                                    </div>
                                              
                                                  </div>
                                              
                                                </div>
                                              
                                              </div>

                                    <div class="ruta-config-module">

                                        <!-- 1️⃣ CONFIGURACIÓN DE RUTA -->
                                        <div class="ruta-card">
                                          <div class="ruta-card-title">
                                            <i style="font-size: 1.3rem;" class="pi pi-compass mr-2"></i>
                                            Configuración de Ruta
                                          </div>
                                      
                                          <div class="ruta-grid">
                                      
                                            <div class="field-group">
                                              <label>Circuito (RT / OW)</label>
                                              <p-dropdown 
                                                [options]="opcionesModoRuta"
                                                optionLabel="label"
                                                optionValue="value"
                                                formControlName="id_modo_ruta"
                                                placeholder="Seleccione"
                                                [showClear]="true"
                                                [style]="{'width':'100%'}">
                                              </p-dropdown>
                                            </div>
                                      
                                            <div class="field-group">
                                              <label>Perfil de Ruta</label>
                                              <p-dropdown 
                                                [options]="opcionesPerfilRuta"
                                                formControlName="perfilRuta"
                                                placeholder="Seleccione perfil"
                                                optionLabel="label"
                                                optionValue="value"
                                                (onChange)="onPerfilRutaChangeDropdown($event)"
                                                [style]="{'width':'100%'}">
                                              </p-dropdown>
                                            </div>
                                      
                                            <div class="field-group">
                                              <label>Importe del Perfil</label>
                                              <input 
                                                type="text"
                                                class="form-control modern-input"
                                                [value]="importeSeleccionado | currency:'MXN'"
                                                disabled>
                                            </div>
                                      
                                            <div class="field-group">
                                              <label>Días Frecuencia</label>
                                              <p-dropdown
                                                [options]="opcionesDiasFrecuencia"
                                                formControlName="num_dias_frecuencia"
                                                placeholder="Días"
                                                optionLabel="label"
                                                optionValue="value"
                                                [style]="{'width':'100%'}">
                                              </p-dropdown>
                                            </div>
                                      
                                          </div>
                                        </div>
                                      
                                      
                                        <!-- 2️⃣ MÉTRICAS OPERATIVAS -->
                                        <div class="ruta-card">
                                          <div class="ruta-card-title">
                                            <i style="font-size: 1.3rem;" class="pi pi-chart-line mr-2"></i>
                                            Métricas Operativas
                                          </div>
                                      
                                          <div class="ruta-grid">
                                      
                                            <div class="metric-group">
                                              <label>Kilómetros</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     min="1"
                                                     formControlName="kilometros">
                                            </div>
                                      
                                            <div class="metric-group">
                                              <label>Horas Carga</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     formControlName="hrs_carga_descarga">
                                            </div>
                                      
                                            <div class="metric-group">
                                              <label>Horas Descarga</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     formControlName="hrs_espera_salida">
                                            </div>
                                      
                                            <div class="metric-group">
                                              <label>Horas Pernocta</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     formControlName="hrs_pernocta">
                                            </div>
                                      
                                          </div>
                                        </div>
                                      
                                      
                                        <!-- 3️⃣ RECURSOS -->
                                        <div class="ruta-card">
                                          <div class="ruta-card-title">
                                            <i style="font-size: 1.3rem;" class="pi pi-users mr-2"></i>
                                            Recursos Humanos
                                          </div>
                                      
                                          <div class="ruta-grid">
                                      
                                            <div class="metric-group">
                                              <label>Número de Choferes</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     formControlName="num_choferes">
                                            </div>
                                      
                                            <div class="metric-group">
                                              <label>Número de Auxiliares</label>
                                              <input type="number"
                                                     class="form-control modern-input"
                                                     formControlName="num_auxiliares">
                                            </div>
                                      
                                          </div>
                                        </div>
                                      
                                      </div>
                                    <div class="row mt-5">
                                        
                                    <div *ngIf="TipoClienteSeleccionado==2" class="form-group col-md-6">
                                    <div class="row g-0 align-items-center">
                                        <div class="col-sm-4 d-flex align-items-center">
                                        <label class="mb-0" style="color:#2454B8; font-weight:bold;">
                                            % Comisión de Terceros
                                        </label>
                                        </div>

                                        <div class="col-sm-8">
                                        <input
                                            pTooltip="Porcentaje Comision Terceros"
                                            type="number"
                                            class="form-control sinborde"
                                            style="font-weight:bold; width:100%;"
                                            formControlName="comision_cliente"
                                            placeholder="Ej. 0.5 a 100"
                                            min="0.5"
                                            step="1"
                                            inputmode="decimal"
                                        />
                                        <small *ngIf="comision?.touched && comision?.errors?.['required']" class="text-danger">
                                            Campo obligatorio
                                        </small>
                                        <small *ngIf="comision?.touched && comision?.errors?.['min']" class="text-danger">
                                            Debe ser mayor a:  0.5
                                        </small>
                                        <hr class="my-0">
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                                    <div class="row d-flex justify-content-center mt-3">
                                        <div class="col-4">
                                            <p *ngIf="!tabuladorForm.valid" class="texto-invalido text-right">
                                                <i class="pi pi-info-circle" style="font-size: 1rem;">Es Necesario
                                                    Proporcionar
                                                    La Informaci&oacute;n Obligatoria(*)</i>
                                            </p>
                                            <p *ngIf="tabuladorForm.valid" class="texto-valido text-right">
                                                <i class="pi pi-check-circle"
                                                    style="font-size: 1rem;">Informaci&oacute;n
                                                    Completa</i>
                                            </p>
                                        </div>
                                        <div class="col-2">
                                            <button class="btn btn-primary form-control" (click)="guardarInformacionTabulador()" 
                                                [disabled]="!tabuladorForm.valid" pTooltip="Cotizar informacion"
                                                tooltipPosition="right">
                                                <span class="text-white">Cotizar</span>
                                                <i class="pi pi-save text-white"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    
        </ng-template>
        <div class="card-content" *ngIf="dspTablaRegreso">
            <div class="row mt-3 mx-0 px-1">
                <div class="view-toggle ">
                    <span class="toggle-label">Vista:</span>
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-table"
                      class="p-button-sm"
                      [class.active]="!isListView"
                      (click)="isListView = false">
                    </button>
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-list"
                      class="p-button-sm"
                      [class.active]="isListView"
                      (click)="isListView = true">
                    </button>
                  </div>
                  
                <ng-container *ngIf="!isListView; else listViewTemplate">
                    <p-table #dt2 [value]="tablaRespuesta" [tableStyle]="{'min-width': '100rem','margin-top':'5px'}"
                        styleClass="p-datatable-sm p-datatable-striped tabulador-premium" dataKey="id" responsiveLayout="scroll"
                        [scrollable]="true" scrollDirection="both" scrollHeight="580px" [paginator]="true" [rows]="10"
                        [rowsPerPageOptions]="[10, 25, 50,100]" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                        [globalFilterFields]="['id_corrida','configuracion','origen','destino','escala','costo','imp_preciodeventa','imp_utilidad',
                    'imp_utilidadmensual','imp_sueldochofer','imp_sueldoaux','imp_combustible','imp_comisioncombustible','imp_cel_gps','imp_imss','imp_hospedaje','imp_viaticos']">
                        <ng-template pTemplate="header">
                            <tr [ngClass]="{'texto_sm':true}">
                                <th pFrozenColumn style="min-width:3rem;width: 3rem;">
                                    #
                                </th>
                                <th pFrozenColumn style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        No. Tabulado
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Conf. Unidad
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Origen

                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Destino
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Escala
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Perfil de ruta
                                    </div>
                                </th>
                                <th  style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Importe perfil de ruta
                                    </div>
                                </th>
                                <th  style="min-width:5rem;width: 5rem;">
                                    <div class="flex align-items-center">
                                        Ciudad
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Número de Dias
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Número de Kilómetros
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Importe peaje
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Costo
                                        <p-sortIcon field="costo"></p-sortIcon>
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Porcentaje UTD
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Precio de Venta
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Utilidad
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Dias de frecuencia
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Precio de frecuencia
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Número de Choferes
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Número de Auxiliares
                                    </div>
                                </th>
                                <th style="min-width:3rem;width: 3rem;">
                                    <div class="flex align-items-center">
                                        Num. Stop
                                    </div>
                                </th>
                                <th style="min-width:4rem;width: 4rem;">
                                    <div class="flex align-items-center">
                                        Imp. Stop
                                    </div>
                                </th>
                                <th style="min-width:3rem;width: 3rem;">
                                    <div class="flex align-items-center">
                                        Maniobras
                                    </div>
                                </th>
                                <th style="min-width:4rem;width: 4rem;">
                                    <div class="flex align-items-center">
                                        Imp. Maniobras
                                    </div>
                                </th>
                                <th style="min-width:3rem;width: 3rem;">
                                    <div class="flex align-items-center">
                                        Truck
                                    </div>
                                </th>
                                <th style="min-width:4rem;width: 4rem;">
                                    <div class="flex align-items-center">
                                        Cost. Km
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Sueldo Chofer
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Sueldo Total Chofer
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Sueldo Auxiliar
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Hospedaje
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Viaticos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Combustible
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Comision Combustible
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                       Gasto Urea
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Herramientas de Seguridad y Monitoreo
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Recursos Humanos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Vehiculos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Mantenimiento Preventivo
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Servicio Correctivo
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Propuesta de Valor
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Permisos de Circulacion
                                    </div>
                                </th>
                                <!-- <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Combustibles y Casetas
                                    </div>
                                </th> -->
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Importe de llantas
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data let-index="rowIndex">
                            <tr [ngClass]="{
                            'row-accessories': data.clv_activo === 0, 
                            'row-error-excel': data.tiene_error,
                            'row-alerta-gerente': data.clv_candado_hrs === 1 && data.clv_aceptado_gte === 0
                            }" 
                            class="tabulador-row">
                                <td pFrozenColumn [frozen]="true" class="texto_negrita">
                                    {{(index+1)}}
                                </td>
                                <td pFrozenColumn [frozen]="true" class="texto_negrita">
                                    <div class="texto_negrita">{{data.id_corrida}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true" class="texto_negrita texto_naranja_ba">
                                    <div class="texto_negrita"> {{data.configuracion}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.origen}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.destino}}
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.escala}}
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">
                                        {{
                                        data.id_perfil_ruta === 1
                                            ? 'ZONA INDUSTRIAL'
                                            : data.id_perfil_ruta === 2
                                            ? 'ZONA METROPOLITANA'
                                            : ''
                                        }}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_perfil_ruta| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto-pesado">{{data.nom_ciudad}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_dias}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_kilometros}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_peaje| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.costo| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">%{{data.num_porcentajeutd}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita colo">{{data.imp_preciodeventa| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_utilidad| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_dias_frecuencia}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_precio_de_frecuencia| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_choferes}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_auxiliares}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_stop_in }}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_stop|currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.clv_maniobras_in==1?'SI':'NO'  }}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_maniobras|currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.clv_truck_in==1?'SI':'NO'  }}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_costo_kilometros|currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_sueldochofer| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.sueldo_total_chofer|currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_sueldoaux| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_hospedaje| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_viaticos| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_combustible| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_comisioncombustible| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_urea| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_cel_gps| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_imss| currency}}</div>
                                </td>
                                
                                <td>
                                    <div class="texto_negrita">{{data.imp_depreciacion| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_mantenimiento| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_serviciocorrectivo| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_propuestavalor| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_permisocirculacion| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_llantas| currency}}</div>
                                </td>
                                <td>
                                <button pButton icon="pi pi-save" styleClass="p-button-sm"
                                    style="margin-right: 10px !important; background-color: rgb(30, 155, 30); border: none;"
                                    [pTooltip]="data.tiene_error ? data.mensaje_error : 'Guardar Tabulado'" 
                                    tooltipPosition="left"
                                    (click)="GuardarTabulado(data);"
                                    [disabled]="data.tiene_error"> 
                                </button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </ng-container>
                <ng-template #listViewTemplate>
                    <!-- Lista/columnas hacia abajo -->
                    <div class="row mt-3 mx-0 px-1 justify-content-center">
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-4" *ngFor="let data of tablaRespuesta">
                                        <div class="tabulado-card">
                                            <!-- HEADER -->
                                            <div class="card-header">

                                                <div class="header-left">
                                                <div class="config"><span>Config </span>{{ data.configuracion }}</div>
                                                <div class="corrida">#{{ data.id_corrida }}</div>
                                                <div class="precio">
                                                   <span>Precio Venta</span> {{ data.imp_preciodeventa | currency }}
                                                </div>
                                                </div>
                                        
                                                <div class="header-image">
                                                <img *ngIf="data.configuracion==='LV'"
                                                    src="../../../assets/images/van.png"
                                                    alt="LV">
                                        
                                                <img *ngIf="data.configuracion==='3.5'"
                                                    src="../../../assets/images/3.5.png"
                                                    alt="3.5">
                                        
                                                <img *ngIf="data.configuracion==='RABON'"
                                                    src="../../../assets/images/rabon.png"
                                                    alt="RABON">
                                        
                                                <img *ngIf="data.configuracion==='THORTON 16T'"
                                                    src="../../../assets/images/rabon.png"
                                                    alt="THORTON">
                                                </div>
                                        
                                            </div>
                                            
                                              <div class="card-body-grid">
                                                <div><span>Origen</span><b>{{ data.origen }}</b></div>
                                                <div><span>Destino</span><b>{{ data.destino }}</b></div>
                                                <div><span>KM</span><b>{{ data.num_kilometros }}</b></div>
                                                <div><span>Costo</span><b>{{ data.costo | currency }}</b></div>
                                                <div><span>Utilidad</span><b>{{ data.imp_utilidad | currency }}</b></div>
                                                <div><span>Dias de frecuencia</span><b>{{data.num_dias_frecuencia }}</b></div>  
                                                <div><span>Numero de Choferes</span><b>{{data.num_choferes}}</b></div>
                                                <div><span>Num Stop:</span><b>{{data.num_stop_in}}</b></div>
                                                <div><span>Num Maniobras:</span><b>{{data.clv_maniobras_in==1?'SI':'NO' }}</b></div>
                                                <div><span>Truck:</span><b>{{data.clv_truck_in==1?'SI':'NO' }}</b></div>
                                                <div><span>Sueldo Chofer:</span><b>{{ data.imp_sueldochofer |currency }}</b></div>
                                                <div><span>Sueldo Total Chofer:</span><b>{{ data.sueldo_total_chofer |currency }}</b></div>
                                                <div><span>Gasto Hospedaje:</span><b>{{ data.imp_hospedaje |currency }}</b></div>
                                                <div><span>Gasto Combustible:</span><b>{{ data.imp_combustible |currency }}</b></div>
                                                <div><span>Gasto Urea: </span><b>{{data.imp_urea | currency }}</b></div>
                                                <div><span>Recursos Humanos:</span><b>{{data.imp_imss | currency }}</b></div>
                                                <div><span>Vehiculos: </span><b>{{data.imp_depreciacion | currency }}</b></div>
                                                <div><span>Servicio Correctivo:</span><b>{{data.imp_serviciocorrectivo | currency }}</b></div>
                                                <div><span>Permisos de Circulacion: </span><b>{{data.imp_permisocirculacion | currency }}</b></div>
                                                <div><span>Perfil de ruta: </span><b>{{ data.id_perfil_ruta === 1 ? 'ZONA INDUSTRIAL' : data.id_perfil_ruta === 2 ? 'ZONA METROPOLITANA' : '' }}</b></div>
                                                <div><span>Ciudad OP: </span><b>{{ data.nom_ciudad }}</b></div>
                                                <div><span>Destino: </span><b>{{ data.destino }}</b></div>
                                                <div><span>Número de Días: </span><b>{{data.num_dias }}</b></div>
                                                <div><span>Importe Peaje: </span><b>{{data.imp_peaje | currency}}</b></div>
                                                <div><span>Porcentaje UTD: </span><b>{{ data.num_porcentajeutd + "%"}}</b></div>
                                                <div><span>Precio de frecuencia: </span><b>{{data.imp_precio_de_frecuencia | currency }}</b></div>
                                                <div><span>Número de Auxiliares: </span><b>{{data.num_auxiliares }}</b></div>
                                                <div><span>Imp. Stop: </span><b>{{data.imp_stop|currency }}</b></div>
                                                <div><span>Maniobras:</span><b>{{data.imp_maniobras|currency }}</b></div>
                                                <div><span>Costo Km: </span><b>{{data.imp_costo_kilometros|currency }}</b></div>
                                                <div><span>Sueldo Auxiliar: </span><b>{{ data.imp_sueldoaux |currency }}</b></div>
                                                <div><span>Gasto Viaticos: </span><b>{{ data.imp_viaticos |currency }}</b></div>
                                                <div><span>Gasto Comisión Combustible: </span><b>{{ data.imp_comisioncombustible |currency }}</b></div>
                                                <div><span>Gasto Celular GPS: </span><b>{{data.imp_cel_gps | currency}}</b></div>
                                                <div><span>Mantenimiento Preventivo: </span><b>{{data.imp_mantenimiento | currency}}</b></div>
                                                <div><span>Propuesta de Valor: </span><b>{{ data.imp_propuestavalor |currency }}</b></div>
                                                <div><span>Importe de llantas: </span><b>{{ data.imp_llantas |currency }}</b></div>
                                                <div><span>Importe de perfil ruta: </span><b>{{ data.imp_perfil_ruta |currency }}</b></div>
                                            </div>
                                        
                                    
                                    
                                
                                <div class="card-footer">
                                <button pButton icon="pi pi-save" styleClass="p-button-sm"
                                    style="margin-right: 10px !important; background-color: rgb(30, 155, 30); border: none;"
                                    [pTooltip]="data.tiene_error ? data.mensaje_error : 'Guardar Tabulado'" 
                                    tooltipPosition="left"
                                    (click)="GuardarTabulado(data);"
                                    [disabled]="data.tiene_error"> 
                                </button>
                                </div>
                                </div>
                                </div>
                            </div>
                </ng-template>
                <div class="align-items-center mt-4">
                    <div class="acciones-bar">
                        <button 
                          pButton 
                          icon="pi pi-refresh"
                          label="Generar Nuevo"
                          class="p-button-outlined"
                          (click)="GenerarNuevoTabulado()">
                        </button>
                      
                        <button 
                          pButton 
                          icon="pi pi-save"
                          label="Guardar Todo"
                          class="p-button-success"
                          [disabled]="loading || tablaRespuesta.length === 0"
                          (click)="GuardarTodoTabulados()">
                        </button>
                      
                      </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
                (click)="cancelarVentanaModal()"></button>
        </ng-template>
    </p-dialog>
    <p-dialog
    [(visible)]="dspFrmCotizacion"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '75vw', maxWidth: '1100px' }"
    [contentStyle]="{ overflow: 'auto', padding: '0' }"
    styleClass="enterprise-dialog">
        <ng-template pTemplate="header">
            Formulario Cotización
        </ng-template>
        <ng-template pTemplate="content">
            <div class="cotizacion-container">
                <form [formGroup]="CotizacionForm" class="cotizacion-form">   
                  <!-- BLOQUE 1 -->
                  <div class="form-section">
                    <h4>Información General</h4>
              
                    <div class="form-grid">
              
                      <div class="field">
                        <label>Contacto *</label>
                        <p-dropdown
                          [options]="cat_nombresContacto"
                          optionLabel="NombreCompletoCto"
                          optionValue="NombreCompletoCto"
                          formControlName="nom_Contacto"
                          placeholder="Seleccionar contacto"
                          class="w-full">
                        </p-dropdown>
                      </div>
              
                      <div class="field">
                        <label>Días Operativos *</label>
                        <input pInputText type="number"
                               formControlName="num_DiasOperativos"
                               placeholder="Ej. 30">
                      </div>
              
                      <div class="field">
                        <label>Fecha Emisión</label>
                        <input pInputText
                               formControlName="fecha_emision">
                      </div>
              
                      <div class="field">
                        <label>Tipo de Jornada *</label>
                        <p-dropdown
                          [options]="cat_diasoperacion"
                          optionLabel="des_diasoperacion"
                          optionValue="id_diasoperacion"
                          formControlName="id_jornadaOperacion"
                          placeholder="Seleccionar jornada"
                          class="w-full">
                        </p-dropdown>
                      </div>
              
                    </div>
                  </div>
              
                  <!-- BLOQUE 2 -->
                  <div class="form-section">
                    <h4>Configuración Operativa</h4>
              
                    <div class="form-grid">
              
                      <div class="field">
                        <label>Horas Espera Descarga</label>
                        <input pInputText type="number"
                               formControlName="hrs_EsperaDescarga">
                      </div>
              
                      <div class="field">
                        <label>Horas Advertencia</label>
                        <input pInputText type="number"
                               formControlName="hrs_Advertencia">
                      </div>
              
                      <div class="field">
                        <label>% Flete en Falso</label>
                        <input pInputText type="number"
                               formControlName="num_porcentajeFleteFalso">
                      </div>
              
                      <div class="field">
                        <label>% Flete Retorno</label>
                        <input pInputText type="number"
                               formControlName="num_porcentajeFleteRetorno">
                      </div>
              
                    </div>
                  </div>
              
                  <!-- BLOQUE 3 -->
                  <div class="form-section">
                    <h4>Condiciones Comerciales</h4>
              
                    <div class="form-grid">
              
                      <div class="field">
                        <label>Días Crédito</label>
                        <input pInputText type="number"
                               formControlName="num_diasCredito">
                      </div>
              
                      <div class="field">
                        <label>Periodo Facturación</label>
                        <p-dropdown
                          [options]="cat_periodofacturacion"
                          optionLabel="des_periodofacturacion"
                          optionValue="id_periodofacturacion"
                          formControlName="id_tipoEvento"
                          class="w-full">
                        </p-dropdown>
                      </div>
              
                      <div class="field">
                        <label>Vigencia Tarifaria (Meses)</label>
                        <input pInputText type="number"
                               formControlName="num_VigenciaTarifaria">
                      </div>
              
                      <div class="field">
                        <label>Días Validez</label>
                        <input pInputText type="number"
                               formControlName="num_DiasValidez">
                      </div>
              
                      <div class="field">
                        <label>Cantidad Repartos</label>
                        <input pInputText type="number"
                               formControlName="num_cantidadrepartos">
                      </div>
              
                    </div>
                  </div>
              
                  <!-- FOOTER ACTIONS -->
                  <div class="form-actions">
              
                    <div class="status">
                      <span *ngIf="!CotizacionForm.valid" class="invalid">
                        Información obligatoria incompleta
                      </span>
              
                      <span *ngIf="CotizacionForm.valid" class="valid">
                        Información completa
                      </span>
                    </div>
              
                    <div class="buttons">
              
                      <button *ngIf="bntDescargarCotizacion"
                              pButton
                              icon="pi pi-file-pdf"
                              label="Generar PDF"
                              class="p-button-secondary"
                              (click)="GenerarCotizacion()">
                      </button>
              
                      <button pButton
                              icon="pi pi-save"
                              label="Guardar"
                              class="p-button-success"
                              [disabled]="!CotizacionForm.valid"
                              (click)="guardarFrmCotizacion()">
                      </button>
              
                    </div>
              
                  </div>
              
                </form>
              </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cerrar" icon="pi pi-times" class="p-button-text"
                (click)="CerrarFrmCotizacion()"></button>
        </ng-template>
    </p-dialog>


<p-dialog styleClass="prospect-dialog tabulador-dialog" header="Grafica del Costo Total" [modal]="true" [(visible)]="dspGrafica"
    [style]="{ width: '90vh',height:'900px'}" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="false" (onHide)="CerrarGrafica()">
    <ng-template pTemplate="container">
        <div class="card-content card-shadow">
            <div class="form-card mt-5 ml-5"
                pTooltip="Costo = Peaje + sueldo chofer + sueldo auxiliar + combustible + comision combustible + Monitoreo + RH Diario + depreciacion + mantenimiento + hospedaje + viaticos + operaciones + seguridadpatrimonia">
                <div class="justify-content-center ml-2">
                    <p-chart type="doughnut" [data]="data" [options]="options" class="ui-chart ui-chart-series" />
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cerrar" icon="pi pi-times" class="p-button-text"
            (click)="CerrarGrafica()"></button>
    </ng-template>
</p-dialog>
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEditarTAbulado" [modal]="true" (onHide)="cancelarVentanaEditarModal()"
[style]="{width: '90vw','height':'1150px'}" [transitionOptions]="'0ms'" styleClass="card-shadow">
        <ng-template pTemplate="header">
            Editar Tabulador
        </ng-template>
        <ng-template pTemplate="content">
            <div class="tabulador-wrapper" *ngIf="dspTablaRegreso===false">
                            <form class="tabulador-form" [formGroup]="EditarTabuladoForm">
                                <div class="ml-2 px-2">

                                    <div class="row mt-5 form-card">
                                        <span style="color: #2454B8;">
                                            <h2><i class="pi pi-wallet" style="font-size: 2rem;"></i> Información Base
                                                Para el Cliente:</h2>
                                        </span>
                                    </div>
                                    <div class="config-panel mt-4">

                                        <div class="panel-header">
                                          <i style="font-size: 1.3rem;" class="pi pi-info-circle mr-2"></i>
                                          Información General
                                        </div>
                                      
                                        <div class="panel-grid">
                                      
                                          <div class="field-group">
                                            <label>Centro de Costos</label>
                                            <p-dropdown
                                              [options]="centrosCostosHm"
                                              optionLabel="municipio"
                                              optionValue="id"
                                              placeholder="Seleccione un centro"
                                              formControlName="centro_costos"
                                              [showClear]="true"
                                              class="w-full">
                                            </p-dropdown>
                                          </div>
                                      
                                          <div class="field-group">
                                            <label>Maniobras</label>
                                            <p-dropdown
                                              [options]="opcionesSiNo"
                                              optionLabel="label"
                                              optionValue="value"
                                              placeholder="Seleccione"
                                              formControlName="maniobras"
                                              [showClear]="true"
                                              class="w-full">
                                            </p-dropdown>
                                          </div>
                                      
                                          <div class="field-group">
                                            <label>Número de Stops</label>
                                            <input
                                              pInputText
                                              type="number"
                                              min="0"
                                              formControlName="num_stop"
                                              class="modern-input w-full"
                                              placeholder="0">
                                          </div>
                                      
                                        </div>
                                      
                                      </div>
                                    
                                     <!-- CARD 2: RUTA -->
                                     <div class="config-panel mt-4">

                                        <div class="panel-header">
                                          <i style="font-size: 1.3rem;"  class="pi pi-map-marker mr-2"></i>
                                          Ruta
                                        </div>
                                      
                                        <div class="panel-grid">
                                      
                                          <!-- Tipo de Ruta -->
                                          <div class="field-group">
                                            <label>Tipo de Ruta</label>
                                            <p-dropdown
                                              [options]="cat_Rutas"
                                              placeholder="Selecciona el Tipo de Ruta"
                                              [(ngModel)]="idruta"
                                              optionLabel="nom_area"
                                              optionValue="id_area"
                                              formControlName="Area"
                                              [showClear]="true"
                                              [appendTo]="'body'"
                                              class="w-full">
                                            </p-dropdown>
                                          </div>
                                      
                                          <!-- Origen -->
                                          <div class="field-group">
                                            <label class="d-flex align-items-center">
                                              <i style="font-size: 1.1rem;" class="fa-solid fa-city mr-2 color-icon"></i>
                                              Origen
                                            </label>
                                      
                                            <div class="modern-input-group">
                                              <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="googleOrigenSearch"
                                                [ngModelOptions]="{ standalone: true }"
                                                placeholder="Ej. Culiacán, Sinaloa, México"
                                                class="w-full">
                                              
                                              <button
                                                pButton
                                                type="button"
                                                icon="pi pi-search"
                                                class="p-button-outlined p-button-secondary"
                                                (click)="buscarDireccionGoogle('origen')"
                                                pTooltip="Buscar Origen"
                                                tooltipPosition="top">
                                              </button>
                                            </div>
                                      
                                            <small class="helper-text">
                                              {{ valNotNullAddress('origenAddr') }}
                                            </small>
                                          </div>
                                      
                                          <!-- Destino -->
                                          <div class="field-group">
                                            <label class="d-flex align-items-center">
                                              <i style="font-size: 1.1rem;"  class="fa-solid fa-city mr-2 color-icon"></i>
                                              Destino
                                            </label>
                                      
                                            <div class="modern-input-group">
                                              <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="googleDestinoSearch"
                                                [ngModelOptions]="{ standalone: true }"
                                                placeholder="Ej. Guadalajara, Jalisco, México"
                                                class="w-full">
                                              
                                              <button
                                                pButton
                                                type="button"
                                                icon="pi pi-search"
                                                class="p-button-outlined p-button-secondary"
                                                (click)="buscarDireccionGoogle('destino')"
                                                pTooltip="Buscar Destino"
                                                tooltipPosition="top">
                                              </button>
                                            </div>
                                      
                                            <small class="helper-text">
                                              {{ valNotNullAddress('destinoAddr') }}
                                            </small>
                                          </div>
                                      
                                        </div>
                                      
                                      </div>

                                    <div class="ruta-container">

                                        <div class="ruta-header">
                                          <div class="ruta-title">
                                            <i class="pi pi-map-marker mr-2"></i>
                                            Ruta con Escalas
                                            <span class="ruta-sub">(Máx. {{maxParadas}})</span>
                                          </div>
                                      
                                          <button
                                            pButton
                                            type="button"
                                            icon="pi pi-plus"
                                            label="Agregar parada"
                                            class="p-button-sm p-button-outlined"
                                            (click)="agregarParada()"
                                            [disabled]="paradas.length >= maxParadas">
                                          </button>
                                        </div>
                                      
                                        <div formArrayName="paradas" class="timeline">
                                      
                                          <div
                                            *ngFor="let paradaCtrl of paradas.controls; let i = index"
                                            [formGroupName]="i"
                                            class="timeline-item">
                                      
                                            <!-- Línea vertical -->
                                            <div class="timeline-marker">
                                              <div class="circle">{{ i + 1 }}</div>
                                              
                                            </div>
                                      
                                            <!-- Contenido -->
                                            <div class="timeline-content">
                                      
                                              <div class="input-row">
                                                <input
                                                  pInputText
                                                  type="text"
                                                  formControlName="texto"
                                                  placeholder="Ciudad, Estado, País" />
                                      
                                                <button
                                                  pButton
                                                  type="button"
                                                  icon="pi pi-search"
                                                  class="p-button-text"
                                                  (click)="buscarDireccionGoogle('parada', i)">
                                                </button>
                                      
                                                <button
                                                  pButton
                                                  type="button"
                                                  icon="pi pi-trash"
                                                  class="p-button-rounded p-button-danger p-button-text"
                                                  (click)="eliminarParada(i)">
                                                </button>
                                              </div>
                                      
                                              <div class="direccion-preview">
                                                {{ valNotNullAddress('escalaAddr', i) }}
                                              </div>
                                      
                                            </div>
                                      
                                          </div>
                                      
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12 d-flex justify-content-end">
                                              <button
                                                pButton
                                                type="button"
                                                icon="pi pi-compass"
                                                label="Calcular KM"
                                                class="p-button-rounded p-button-success px-4 shadow-2"
                                                (click)="calcularRuta()"
                                                [disabled]="EditarTabuladoForm.get('tipo_tabulado')?.value !== 1 || rutaCalculada">
                                              </button>
                                            </div>
                                          </div>
                                      
                                      </div>

                                      <div class="config-module">

                                        <!-- HEADER -->
                                        <div class="config-header">
                                          <div>
                                            <div class="config-title">
                                              <i class="fa-solid fa-truck mr-2"></i>
                                              Configuración de Unidades
                                            </div>
                                            <div class="config-sub">
                                              Define el importe de caseta y utilidad por tipo de unidad.
                                            </div>
                                          </div>
                                        </div>
                                      
                                        <!-- SELECTOR -->
                                        <div class="config-selector">
                                          <p-dropdown [options]="cat_ConfiguracionUnidades"
                                          [(ngModel)]="configuracionSeleccionada"
                                            optionValue="idx_respaldo_confunidad"
                                            optionLabel="nombre"
                                            formControlName="configuracion_Unidad"
                                            display="chip"
                                            [appendTo]="'body'"
                                            [style]="{'width':'100%'}"
                                            (ngModelChange)="Configi()"
                                            (onChange)="handleChange($event)">
                                          </p-dropdown>
                                        </div>
                                      
                                      <div *ngIf="objImporteCaseta.length > 0" class="config-summary">
                                        <div class="summary-title">
                                            <i class="pi pi-check-circle mr-2"></i>
                                            Configuraciones Guardadas
                                        </div>

                                        <div class="summary-grid">
                                            <div *ngFor="let item of objImporteCaseta; let idx = index" class="summary-card" style="position: relative;">
                                            
                                            <button pButton type="button" icon="pi pi-trash" 
                                                    class="p-button-danger p-button-text" 
                                                    style="position: absolute; top: 5px; right: 5px; width: 2rem; height: 2rem; padding: 0;"
                                                    pTooltip="Eliminar Configuración"
                                                    (click)="eliminarImporteGuardado(idx)">
                                            </button>

                                            <div class="summary-name">
                                                {{ getNombreConfiguracion(item.id_configuracion) }}
                                            </div>

                                            <div class="summary-values">
                                                <span class="importe">
                                                {{ item.importeCasetaConfiguracion | currency:'MXN' }}
                                                </span>
                                                <span class="utilidad">
                                                {{ item.porcentajeUtilidadConfiguracion }}%
                                                </span>
                                            </div>

                                            </div>
                                        </div>
                                        </div>
                                      
                                        <!-- FORMULARIOS DINÁMICOS -->
                                        <div class="config-forms">
                                      
                                          <div *ngFor="let configuracionimporte of importesForm; let i = index"
                                               [formGroup]="configuracionimporte"
                                               class="config-card">
                                      
                                            <div class="card-header-custom">
                                              <span class="card-title">
                                               {{ configuracionimporte.get('nombre')?.value }}
                                              </span>
                                            </div>
                                      
                                            <div class="card-body-custom">
                                      
                                              <div class="form-row-custom">
                                      
                                                <!-- IMPORTE -->
                                                <div class="form-group-custom">
                                                  <label>Importe Caseta</label>
                                                  <p-inputNumber
                                                    mode="currency"
                                                    currency="MXN"
                                                    formControlName="importeCasetaConfiguracion"
                                                    [style]="{'width':'100%'}"
                                                    [showClear]="!rutaCalculada">
                                                  </p-inputNumber>
                                                </div>
                                      
                                                <!-- UTILIDAD -->
                                                <div class="form-group-custom">
                                                  <label>% Utilidad</label>
                                                  <p-inputNumber
                                                    suffix="%"
                                                    formControlName="porcentajeUtilidadConfiguracion"
                                                    [min]="0"
                                                    [max]="100"
                                                    [style]="{'width':'100%'}">
                                                  </p-inputNumber>
                                                </div>
                                      
                                                <!-- BOTÓN -->
                                                <div class="form-button-custom">
                                                  <button
                                                    pButton
                                                    type="button"
                                                    icon="pi pi-check"
                                                    label="Guardar"
                                                    class="p-button-success"
                                                    (click)="addImporteForm(configuracionimporte,i)"
                                                    [disabled]="!configuracionimporte.valid">
                                                  </button>
                                                </div>
                                      
                                              </div>
                                      
                                            </div>
                                      
                                          </div>
                                      
                                        </div>
                                      
                                      </div>

                            <div class="ruta-config-module">

                                <!-- 1️⃣ CONFIGURACIÓN DE RUTA -->
                                <div class="ruta-card">
                                  <div class="ruta-card-title">
                                    <i style="font-size: 1.3rem;" class="pi pi-compass mr-2"></i>
                                    Configuración de Ruta
                                  </div>
                              
                                  <div class="ruta-grid">
                              
                                    <div class="field-group">
                                      <label>Circuito (RT / OW)</label>
                                      <p-dropdown 
                                        [options]="opcionesModoRuta"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="id_modo_ruta"
                                        placeholder="Seleccione"
                                        [showClear]="true"
                                        [style]="{'width':'100%'}">
                                      </p-dropdown>
                                    </div>
                              
                                    <div class="field-group">
                                      <label>Perfil de Ruta</label>
                                      <p-dropdown 
                                        [options]="opcionesPerfilRuta"
                                        formControlName="perfilRuta"
                                        placeholder="Seleccione perfil"
                                        optionLabel="label"
                                        optionValue="value"
                                        (onChange)="onPerfilRutaChangeDropdown($event)"
                                        [style]="{'width':'100%'}">
                                      </p-dropdown>
                                    </div>
                              
                                    <div class="field-group">
                                      <label>Importe del Perfil</label>
                                      <input 
                                        type="text"
                                        class="form-control modern-input"
                                        [value]="importeSeleccionado | currency:'MXN'"
                                        disabled>
                                    </div>
                              
                                    <div class="field-group">
                                      <label>Días Frecuencia</label>
                                      <p-dropdown
                                        [options]="opcionesDiasFrecuencia"
                                        formControlName="num_dias_frecuencia"
                                        placeholder="Días"
                                        optionLabel="label"
                                        optionValue="value"
                                        [style]="{'width':'100%'}">
                                      </p-dropdown>
                                    </div>
                              
                                  </div>
                                </div>
                              
                              
                                <!-- 2️⃣ MÉTRICAS OPERATIVAS -->
                                <div class="ruta-card">
                                  <div class="ruta-card-title">
                                    <i style="font-size: 1.3rem;" class="pi pi-chart-line mr-2"></i>
                                    Métricas Operativas
                                  </div>
                              
                                  <div class="ruta-grid">
                              
                                    <div class="metric-group">
                                      <label>Kilómetros</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             min="1"
                                             formControlName="kilometros">
                                    </div>
                              
                                    <div class="metric-group">
                                      <label>Horas Carga</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             formControlName="hrs_carga_descarga">
                                    </div>
                              
                                    <div class="metric-group">
                                      <label>Horas Descarga</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             formControlName="hrs_espera_salida">
                                    </div>
                              
                                    <div class="metric-group">
                                      <label>Horas Pernocta</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             formControlName="hrs_pernocta">
                                    </div>
                              
                                  </div>
                                </div>
                              
                              
                                <!-- 3️⃣ RECURSOS -->
                                <div class="ruta-card">
                                  <div class="ruta-card-title">
                                    <i style="font-size: 1.3rem;" class="pi pi-users mr-2"></i>
                                    Recursos Humanos
                                  </div>
                              
                                  <div class="ruta-grid">
                              
                                    <div class="metric-group">
                                      <label>Número de Choferes</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             formControlName="num_choferes">
                                    </div>
                              
                                    <div class="metric-group">
                                      <label>Número de Auxiliares</label>
                                      <input type="number"
                                             class="form-control modern-input"
                                             formControlName="num_auxiliares">
                                    </div>
                              
                                  </div>
                                </div>
                              
                              </div>
                                              
                                    <div class="row mt-5">
                                       
                                    <div *ngIf="TipoClienteSeleccionado==2" class="form-group col-md-6">
                                    <div class="row g-0 align-items-center">
                                        <div class="col-sm-4 d-flex align-items-center">
                                        <label class="mb-0" style="color:#2454B8; font-weight:bold;">
                                            % Comisión de Terceros
                                        </label>
                                        </div>

                                        <div class="col-sm-8">
                                        <input
                                            pTooltip="Porcentaje Comision Terceros"
                                            type="number"
                                            class="form-control sinborde"
                                            style="font-weight:bold; width:100%;"
                                            formControlName="comision_cliente"
                                            placeholder="Ej. 0.5 a 100"
                                            min="0.5"
                                            step="1"
                                            inputmode="decimal"
                                        />
                                        <small *ngIf="comision?.touched && comision?.errors?.['required']" class="text-danger">
                                            Campo obligatorio
                                        </small>
                                        <small *ngIf="comision?.touched && comision?.errors?.['min']" class="text-danger">
                                            Debe ser mayor a:  0.5
                                        </small>
                                        <hr class="my-0">
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                                    <div class="row d-flex justify-content-center mt-3">
                                        <div class="col-4">
                                            <p *ngIf="!EditarTabuladoForm.valid" class="texto-invalido text-right">
                                                <i class="pi pi-info-circle" style="font-size: 1rem;">Es Necesario
                                                    Proporcionar
                                                    La Informaci&oacute;n Obligatoria(*)</i>
                                            </p>
                                            <p *ngIf="EditarTabuladoForm.valid" class="texto-valido text-right">
                                                <i class="pi pi-check-circle"
                                                    style="font-size: 1rem;">Informaci&oacute;n
                                                    Completa</i>
                                            </p>
                                        </div>
                                        <div class="col-2">
                                            <button class="btn btn-primary form-control" (click)="guardarInformacionEditarTabulador()" 
                                                [disabled]="!EditarTabuladoForm.valid || objImporteCaseta.length === 0" pTooltip="Cotizar información"
                                                tooltipPosition="right">
                                                <span class="text-white">Cotizar</span>
                                                <i class="pi pi-save text-white"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
            </div>
        </ng-template>
        <div class="card-content" *ngIf="dspTablaRegreso">
            <div class="row mt-3 mx-0 px-1">
                <div class="view-toggle ">
                    <span class="toggle-label">Vista:</span>
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-table"
                      class="p-button-sm"
                      [class.active]="!isListView"
                      (click)="isListView = false">
                    </button>
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-list"
                      class="p-button-sm"
                      [class.active]="isListView"
                      (click)="isListView = true">
                    </button>
                  </div>
                <ng-container *ngIf="!isListView; else listViewTemplate">
                    <p-table #dt2 [value]="TablaRespuestaEditar" [tableStyle]="{'min-width': '100rem','margin-top':'5px'}"
                    styleClass="p-datatable-sm p-datatable-striped tabulador-premium" dataKey="id" responsiveLayout="scroll"
                        [scrollable]="true" scrollDirection="both" scrollHeight="580px" [paginator]="true" [rows]="10"
                        [rowsPerPageOptions]="[10, 25, 50,100]" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                        [globalFilterFields]="['id_corrida','configuracion','origen','destino','escala','costo','imp_preciodeventa','imp_utilidad',
                    'imp_utilidadmensual','imp_sueldochofer','imp_sueldoaux','imp_combustible','imp_comisioncombustible','imp_cel_gps','imp_imss','imp_hospedaje','imp_viaticos']">
                        <ng-template pTemplate="header">
                            <tr [ngClass]="{'texto_sm':true}">
                                <th pFrozenColumn style="min-width:5rem;width: 5rem;">
                                    #
                                </th>
                                <th pFrozenColumn style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        No. Tabulado
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Conf. Unidad
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Origen

                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Destino
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Escala
                                    </div>
                                </th>
                                <th pFrozenColumn style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Perfil de ruta
                                    </div>
                                </th>
                                <th  style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Importe perfil de ruta
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Ciudad
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Número de Dias
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Número de Kilómetros
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Importe peaje
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Costo
                                        <p-sortIcon field="costo"></p-sortIcon>
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Porcentaje UTD
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Precio de Venta
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Utilidad
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Dias de frecuencia
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Precio de frecuencia
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Número de Choferes
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Número de Auxiliares
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Sueldo Chofer
                                    </div>
                                </th>
                                <th style="min-width:8rem;width: 8rem;">
                                    <div class="flex align-items-center">
                                        Sueldo Auxiliar
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Hospedaje
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Viaticos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Combustible
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Comision Combustible
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                       Gasto Urea
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Gasto Celular GPS
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Recursos Humanos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Vehiculos
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Mantenimiento Preventivo
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Servicio Correctivo
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Propuesta de Valor
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Permisos de Circulacion
                                    </div>
                                </th>
                                <!-- <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Combustibles y Casetas
                                    </div>
                                </th> -->
                                <th style="min-width:10rem;width: 10rem;">
                                    <div class="flex align-items-center">
                                        Importe de llantas
                                    </div>
                                </th>
                                <th style="min-width:10rem;width: 10rem;">
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data let-index="rowIndex">
                            <tr [ngClass]="{'row-accessories': data.clv_activo ===0}">
                                <td pFrozenColumn [frozen]="true" class="texto_negrita">
                                    {{(index+1)}}
                                </td>
                                <td pFrozenColumn [frozen]="true" class="texto_negrita">
                                    <div class="texto_negrita">{{data.id_corrida}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true" class="texto_negrita texto_naranja_ba">
                                    <div class="texto_negrita"> {{data.configuracion}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.origen}}</div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.destino}}
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">{{data.escala}}
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="true">
                                    <div class="texto_negrita texto_verde_oliva">
                                        {{
                                        data.id_perfil_ruta === 1
                                            ? 'ZONA INDUSTRIAL'
                                            : data.id_perfil_ruta === 2
                                            ? 'ZONA METROPOLITANA'
                                            : ''
                                        }}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_perfil_ruta| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto-pesado texto_verde_oliva">{{data.nom_ciudad}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_dias}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_kilometros}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_peaje| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.costo| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">%{{data.num_porcentajeutd}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita colo">{{data.imp_preciodeventa| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_utilidad| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_dias_frecuencia}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_precio_de_frecuencia| currency}}
                                    </div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_choferes}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.num_auxiliares}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_sueldochofer| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_sueldoaux| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_hospedaje| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_viaticos| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_combustible| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_comisioncombustible| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_urea| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_cel_gps| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_imss| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_depreciacion| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_mantenimiento| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_serviciocorrectivo| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_propuestavalor| currency}}</div>
                                </td>
                                <td>
                                    <div class="texto_negrita">{{data.imp_permisocirculacion| currency}}</div>
                                </td>
                                <!-- <td>
                                    <div class="texto_negrita">{{data.imp_combustible_casetas| currency}}</div>
                                </td> -->
                                <td>
                                    <div class="texto_negrita">{{data.imp_llantas| currency}}</div>
                                </td>
                                <td>
                                    <button pButton icon="pi pi-save" styleClass="p-button-sm"
                                        style="margin-right: 10px !important; background-color: rgb(30, 155, 30); width: 52px; border: none;"
                                        pTooltip="Guardar Tabulado" tooltipPosition="top"
                                        (click)="GuardarEditarTabulado(data);">
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </ng-container>
                <ng-template #listViewTemplate>
                    <!-- Lista/columnas hacia abajo -->
                    <div class="row mt-3 mx-0 px-1 justify-content-center">
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-4" *ngFor="let data of TablaRespuestaEditar">
                                        <div class="tabulado-card">
                                            <!-- HEADER -->
                                            <div class="card-header">

                                                <div class="header-left">
                                                <div class="config"><span>Config </span>{{ data.configuracion }}</div>
                                                <div class="corrida">#{{ data.id_corrida }}</div>
                                                <div class="precio">
                                                   <span>Precio Venta</span> {{ data.imp_preciodeventa | currency }}
                                                </div>
                                                </div>
                                        
                                                <div class="header-image">
                                                <img *ngIf="data.configuracion==='LV'"
                                                    src="../../../assets/images/van.png"
                                                    alt="LV">
                                        
                                                <img *ngIf="data.configuracion==='3.5'"
                                                    src="../../../assets/images/3.5.png"
                                                    alt="3.5">
                                        
                                                <img *ngIf="data.configuracion==='RABON'"
                                                    src="../../../assets/images/rabon.png"
                                                    alt="RABON">
                                        
                                                <img *ngIf="data.configuracion==='THORTON 16T'"
                                                    src="../../../assets/images/rabon.png"
                                                    alt="THORTON">
                                                </div>
                                        
                                            </div>
                                            
                                              <div class="card-body-grid">
                                                <div><span>Origen</span><b>{{ data.origen }}</b></div>
                                                <div><span>Destino</span><b>{{ data.destino }}</b></div>
                                                <div><span>Ciudad OP: </span><b>{{ data.nom_ciudad }}</b></div>
                                                <div><span>KM</span><b>{{ data.num_kilometros }}</b></div>
                                                <div><span>Costo</span><b>{{ data.costo | currency }}</b></div>
                                                <div><span>Utilidad</span><b>{{ data.imp_utilidad | currency }}</b></div>
                                                <div><span>Dias de frecuencia</span><b>{{data.num_dias_frecuencia }}</b></div>  
                                                <div><span>Numero de Choferes</span><b>{{data.num_choferes}}</b></div>
                                                <div><span>Num Stop:</span><b>{{data.num_stop_in}}</b></div>
                                                <div><span>Num Maniobras:</span><b>{{data.clv_maniobras_in==1?'SI':'NO' }}</b></div>
                                                <div><span>Truck:</span><b>{{data.clv_truck_in==1?'SI':'NO' }}</b></div>
                                                <div><span>Sueldo Chofer:</span><b>{{ data.imp_sueldochofer |currency }}</b></div>
                                                <div><span>Sueldo Total Chofer:</span><b>{{ data.sueldo_total_chofer |currency }}</b></div>
                                                <div><span>Gasto Hospedaje:</span><b>{{ data.imp_hospedaje |currency }}</b></div>
                                                <div><span>Gasto Combustible:</span><b>{{ data.imp_combustible |currency }}</b></div>
                                                <div><span>Gasto Urea: </span><b>{{data.imp_urea | currency }}</b></div>
                                                <div><span>Recursos Humanos:</span><b>{{data.imp_imss | currency }}</b></div>
                                                <div><span>Vehiculos: </span><b>{{data.imp_depreciacion | currency }}</b></div>
                                                <div><span>Servicio Correctivo:</span><b>{{data.imp_serviciocorrectivo | currency }}</b></div>
                                                <div><span>Permisos de Circulacion: </span><b>{{data.imp_permisocirculacion | currency }}</b></div>
                                                <div><span>Perfil de ruta: </span><b>{{ data.id_perfil_ruta === 1 ? 'ZONA INDUSTRIAL' : data.id_perfil_ruta === 2 ? 'ZONA METROPOLITANA' : '' }}</b></div>
                                                <div><span>Ciudad OP: </span><b>{{ data.nom_ciudad }}</b></div>
                                                <div><span>Destino: </span><b>{{ data.destino }}</b></div>
                                                <div><span>Número de Días: </span><b>{{data.num_dias }}</b></div>
                                                <div><span>Importe Peaje: </span><b>{{data.imp_peaje | currency}}</b></div>
                                                <div><span>Porcentaje UTD: </span><b>{{ data.num_porcentajeutd + "%"}}</b></div>
                                                <div><span>Precio de frecuencia: </span><b>{{data.imp_precio_de_frecuencia | currency }}</b></div>
                                                <div><span>Número de Auxiliares: </span><b>{{data.num_auxiliares }}</b></div>
                                                <div><span>Imp. Stop: </span><b>{{data.imp_stop|currency }}</b></div>
                                                <div><span>Maniobras:</span><b>{{data.imp_maniobras|currency }}</b></div>
                                                <div><span>Costo Km: </span><b>{{data.imp_costo_kilometros|currency }}</b></div>
                                                <div><span>Sueldo Auxiliar: </span><b>{{ data.imp_sueldoaux |currency }}</b></div>
                                                <div><span>Gasto Viaticos: </span><b>{{ data.imp_viaticos |currency }}</b></div>
                                                <div><span>Gasto Comisión Combustible: </span><b>{{ data.imp_comisioncombustible |currency }}</b></div>
                                                <div><span>Gasto Celular GPS: </span><b>{{data.imp_cel_gps | currency}}</b></div>
                                                <div><span>Mantenimiento Preventivo: </span><b>{{data.imp_mantenimiento | currency}}</b></div>
                                                <div><span>Propuesta de Valor: </span><b>{{ data.imp_propuestavalor |currency }}</b></div>
                                                <div><span>Importe de llantas: </span><b>{{ data.imp_llantas |currency }}</b></div>
                                                <div><span>Importe de perfil ruta: </span><b>{{ data.imp_perfil_ruta |currency }}</b></div>
                                            </div>
                                <div class="card-footer">
                                    <button 
                                      pButton 
                                      icon="pi pi-save"
                                      label="Guardar"
                                      class="p-button-sm p-button-success"
                                      (click)="GuardarEditarTabulado(data)">
                                    </button>
                                  </div>
                                </div>
                                </div>
                            </div>
                </ng-template>
                
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
                (click)="cancelarVentanaEditarModal()"></button>
        </ng-template>
    </p-dialog>

    <p-dialog 
    styleClass="detalle-dialog-premium"
    [resizable]="false"
    [modal]="true"
    [maximizable]="false"
    appendTo="body"
    [(visible)]="dspVerDetallado"
    [style]="{'width': '60vw','height':'100vh'}"
    (onHide)="cancelarVentanaVerDetallado()">
  
    <!-- HEADER -->
    <ng-template pTemplate="header">
      <div class="dialog-header-premium">
        <i style="font-size: 1.4rem;" class="pi pi-cog mr-2"></i>
        {{ texto_header }}
      </div>
    </ng-template>
  
    <!-- CONTENT -->
    <ng-template pTemplate="content">
  
      <div class="detalle-container">
  
        <div class="section-title">
          Detalles de los subconceptos Unidad 
          <span class="config-highlight">{{ texto_configuracion }}</span>
        </div>
  
        <!-- LISTADO -->
        <div class="conceptos-grid">
  
          <div class="concepto-card"
               *ngFor="let item of CategoriasDetalle">
  
            <div class="concepto-left">
              <div class="concepto-descripcion">
                {{ item.descripcion }}
              </div>
            </div>
  
            <div class="concepto-right">
  
              <div class="importe" [ngClass]="{
                'positivo':item.importe>0,
                'neutro':item.importe===0
              }">
                {{ item.importe | currency }}
              </div>
  
              <div class="estado-badge"
                   [ngClass]="{
                     'activo': item.clv_activo === 1,
                     'inactivo': item.clv_activo !== 1
                   }">
                {{ item.clv_activo === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </div>
  
            </div>
  
          </div>
  
        </div>
  
        <!-- TOTAL -->
        <div class="total-box">
  
          <div class="total-label">
            Total (Importes Activos)
          </div>
  
          <div class="total-amount">
            {{ totalImporteActivo | currency }}
          </div>
  
          <div class="total-extra">
  
            <div *ngIf="id_categoria === 7; else otherCategories">
              Total por {{ num_kilometros_tabulador }} KM =
              <b>{{ totalImportes | currency }}</b>
            </div>
  
            <ng-template #otherCategories>
              Total por {{ num_dias_tabulador }} Días =
              <b>{{ ImportePorDia | currency }}</b>
            </ng-template>
  
            <span *ngIf="NumPersonal > 0">
              | {{ NumPersonal }} Personas Asignadas
            </span>
  
          </div>
  
        </div>
  
      </div>
  
    </ng-template>
  
    <!-- FOOTER -->
    <ng-template pTemplate="footer">
      <button 
        pButton 
        label="Cerrar" 
        icon="pi pi-times"
        class="p-button-text"
        (click)="cancelarVentanaVerDetallado()">
      </button>
    </ng-template>
  
  </p-dialog>
  
<p-blockUI [blocked]="loadingMasiva || isSaving" [baseZIndex]="99999">
    <div class="loading-container">
        <div class="card loading-card">
            <div class="card-body text-center">
                <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #2454B8;"></i>
                
                <h4 class="mt-3" style="color: #2454B8; font-weight: bold;">
                    {{ loadingMasiva ? 'Calculando Rutas' : 'Guardando Información' }}
                </h4>
                
                <p class="mb-0">
                    {{ loadingMasiva ? 'Procesando archivo masivo, por favor espere...' : 'Guardando registros en base de datos...' }}
                </p>
                
                <small class="text-muted" *ngIf="loadingMasiva">
                    Esto puede tardar unos segundos dependiendo del tamaño del archivo.
                </small>
            </div>
        </div>
    </div>
</p-blockUI>
<p-dialog [(visible)]="dspOfrecerRuta" [modal]="true" [style]="{width: '70vw'}" header="Proceso de Alta y Registro de Ruta" [draggable]="false" [resizable]="false">
    <div class="p-fluid mt-3">
        
        <div class="config-panel mb-4">
            <div class="panel-header bg-primary text-white p-2 border-round-top" style="background-color: #2454B8;">
                <i class="pi pi-folder mr-2"></i> 1. Alta de Cliente
            </div>
            <div class="p-3 border-1 border-300 border-round-bottom surface-50">
                <div *ngIf="!clienteEnlazado" class="flex align-items-center justify-content-between p-3 bg-yellow-100 border-round mb-3">
                    <span class="font-bold text-yellow-800"><i class="pi pi-exclamation-triangle mr-2"></i> Cliente no encontrado en HappyMile.</span>
                    <button pButton label="Dar de Alta Cliente" icon="pi pi-user-plus" class="p-button-warning w-auto" (click)="ejecutarAltaCliente()"></button>
                </div>
                <div *ngIf="clienteEnlazado" class="p-3 bg-green-100 text-green-800 font-bold border-round border-1 border-green-300 text-center">
                    <i class="pi pi-check-circle mr-2" style="font-size: 1.2rem;"></i> Cliente verificado y enlazado en catálogo general TDO.
                </div>
            </div>
        </div>

        <div class="config-panel mb-4">
            <div class="panel-header text-white p-2 border-round-top" style="background-color: #d32f2f;">
                <i class="pi pi-map-marker mr-2"></i> 2. Alta de Ruta
            </div>
            <div class="p-3 border-1 border-300 border-round-bottom surface-50">
                
                <div class="grid mb-3">
                    <div class="col-12 md:col-6 field">
                        <label class="font-bold text-500">Origen:</label>
                        <div class="p-2 border-round surface-100 border-1 border-200">
                            {{ data_tabulador?.des_origen || data_tabulador?.origen }}
                        </div>
                    </div>
                    <div class="col-12 md:col-6 field">
                        <label class="font-bold text-500">Destino:</label>
                        <div class="p-2 border-round surface-100 border-1 border-200">
                            {{ data_tabulador?.des_destino || data_tabulador?.destino }}
                        </div>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold text-500">Configuración:</label>
                        <div class="p-2 border-round surface-100 border-1 border-200 text-primary font-bold">
                            {{ data_tabulador?.config_unidad || data_tabulador?.configuracion }}
                        </div>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold text-500">Número de Días:</label>
                        <div class="p-2 border-round surface-100 border-1 border-200">
                            {{ data_tabulador?.num_dias }} días
                        </div>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold text-500">Precio Venta:</label>
                        <div class="p-2 border-round surface-200 border-1 border-300 font-bold text-green-700">
                            {{ data_tabulador?.imp_preciodeventa | currency }}
                        </div>
                    </div>
                </div>

                <hr class="my-3" style="border: 0; border-top: 1px solid #dee2e6;">

                <div class="grid" [formGroup]="rutaForm">
                    <div class="col-12 field">
                        <label class="font-bold" style="color: #2454B8;">Folio de Proyecto (PP-XX):</label>
                        <input pInputText type="text" formControlName="nombreRutaManual" 
                            placeholder="Ej. PP-01" 
                            [readonly]="rutaGeneradaExito || claveRutaGeneradaId > 0">
                    </div>
                </div>

                <div class="flex flex-column align-items-center mt-3">
                    <button *ngIf="!rutaGeneradaExito" pButton label="Generar Ruta" 
                            icon="pi pi-cog" class="p-button-primary w-auto mb-3"  
                            [disabled]="!clienteEnlazado || rutaForm.get('nombreRutaManual')?.invalid || claveRutaGeneradaId > 0"
                            (click)="generarRutaOperativa()">
                    </button>
                    
                    <div *ngIf="rutaGeneradaExito" class="p-3 bg-green-100 border-round text-green-800 font-bold w-full text-center border-1 border-green-300" style="font-size: 1.1rem;">
                        <i class="pi pi-verified mr-2"></i> Clave de Ruta Generada: {{ claveRutaGeneradaTexto }}
                    </div>
                </div>
            </div>
        </div>

        <div class="config-panel mb-2">
            <div class="panel-header text-white p-2 border-round-top" style="background-color: #1e1e1e;">
                <i class="pi pi-wallet mr-2"></i> 3. Registro de Tabulador de Nómina
            </div>
            <div class="p-3 border-1 border-300 border-round-bottom surface-50" [formGroup]="tabForm">
                <div class="grid">
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold">Sueldo Total Chofer:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="sueldo_total_chofer"></p-inputNumber>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold">Viáticos Total Chofer:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="imp_viaticos_chofer"></p-inputNumber>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold">Hospedaje Chofer:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="imp_hospedaje_chofer"></p-inputNumber>
                    </div>
                </div>
                <div class="grid" *ngIf="data_tabulador?.num_auxiliares!=0">
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold">Sueldo Total Aux:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="imp_sueldoaux"></p-inputNumber>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label class="font-bold">Viáticos Total Aux:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="imp_viaticos_aux"></p-inputNumber>
                    </div>
                     <div class="col-12 md:col-4 field">
                        <label class="font-bold">Hospedaje Aux:</label>
                        <p-inputNumber mode="currency" currency="MXN" formControlName="imp_hospedaje_aux"></p-inputNumber>
                    </div>
                </div>
                <div class="text-center mt-4">
                    <button pButton label="Registrar Tabulador" icon="pi pi-save" class="p-button-success w-auto" 
                            [disabled]="!rutaGeneradaExito"
                            (click)="registrarTabuladorFinal()">
                    </button>
                </div>
            </div>
        </div>

    </div>
</p-dialog>